import * as React from "react";
import uncheck from '../../resources/img/checkbox/checkbox_unchecked.png'
import check from '../../resources/img/checkbox/checkbox_checked.png'
import PopDetail from "../popdetail";
import AddNewProjectPane from "../v1/project/add_new_project_pane";
import ReadService from "../../service/read";
import Wait from "../wait";
import SecondLayer from "../container/second_layer";
import ProjectContainer from "./../v1/project/project_container";
import {ProjectsService} from "../../service/v1/projects";
import {AuthorizationService} from "../../service/v1/authorization";
import jwt_decode from "jwt-decode";
import {LocalitiesService} from "../../service/v1/localities";
import BuyLandUSePane from "./buy_land_use_pane";
import GridLayout from "react-grid-layout";
import './../../../node_modules/react-grid-layout/css/styles.css';
import './../../../node_modules/react-resizable/css/styles.css';
import map_image from "../../resources/img/login_bg2.png";
import LandUsePlansPane from "../v1/project/land_use_plans";

export default class FilesListPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rc_codes: [], userToSearch: '', modules: [],//'All Projects','Village LU','District LU','Regional LU','Zonal LU','National LU','CCRO','Urasimishaji'
            projects: [], syncBtn: 'Sync All', current_tab: 0, totalPages: 1, next: null, previous: null, pageSize: 20
        }

        FilesListPane.self = this
        this.fetchProjects = this.fetchProjects.bind(this)
        this.fetchProjectsByUrl = this.fetchProjectsByUrl.bind(this)

        this.handleChange = this.handleChange.bind(this)
        FilesListPane.loadData = FilesListPane.loadData.bind(this)
    }

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    toggleCheck(i, userId) {
        let doc = document.getElementById('chk_' + i);
        if (doc.src === uncheck) {
            doc.src = check;

            return;
        }
        doc.src = uncheck;
    }

    componentDidMount() {
        FilesListPane.loadData()
    }

    static self;

    static loadData() {
        try {
            Wait.show('Loading...')
            ProjectsService.fetchProjects().then(r => {
                Wait.dismiss()
                try {
                    let modules = [{name: 'All', id: 0}]
                    r.data.results.forEach(d => modules.push(d))
                    FilesListPane.self.setState({modules: modules})
                } catch (e) {
                    console.log(e)
                }

                FilesListPane.self.fetchProjects(0, {name: 'All', id: 0})

            })

        } catch (e) {
            console.log(e)
        }
    }

    fetchProjects(i = 0, d) {
        //this.setState({current_tab:i})
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjects(this.props.moduleId).then(r => {
                Wait.dismiss()
                try {
                    //console.log(r.data)
                    this.setState({
                        projects: r.data.results, totalPages: r.data.count, next: r.data.next, previous: r.data.previous
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    fetchProjectsByUrl(url) {
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjectsByUrl(url).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        projects: r.data.results, totalPages: r.data.count, next: r.data.next, previous: r.data.previous
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }


    render() {

        // Get All locality levels and put to session
        LocalitiesService.fetchLocalityLevel().then(r => {
            Wait.dismiss()
            try {
                let response = JSON.stringify(r.data.results)
                //console.log('HAPA : ' + response)
                JSON.parse(response).forEach(level => {
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("nation")) {
                        sessionStorage.setItem('national_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("zone")) {
                        sessionStorage.setItem('zonal_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("region")) {
                        sessionStorage.setItem('regional_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("district")) {
                        sessionStorage.setItem('district_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("village")) {
                        sessionStorage.setItem('village_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("ward")) {
                        sessionStorage.setItem('ward_level_id', level.id)
                    }
                })
                //console.log('region : ' + sessionStorage.getItem('regional_level_id'))

            } catch (e) {
                console.log(e)
            }
        })

        return (<div style={{
            width: '98.9%',
            margin: '4px',
            border: '1px solid #dddd',
            padding: '4px',
            height: '90vh',
            borderTop: '1px solid #efefef',
            overflowX: 'hidden',
            overflowY: 'auto'
        }}>
            <div className={'col col-sm-12'} style={{
                padding: '8px',
                background: '#efefef',
                border: '1px solid #ccc',
                marginBottom: '4px',
                width: 'fit-content',
                float: 'right'
            }}>
                <button className={'btn submit'} style={{float: 'right'}} onClick={() => {
                    PopDetail.show('Buy New Land Use Plan', <LandUsePlansPane
                                                                            key={new Date().getMilliseconds()}/>, 80)
                }}>
                    <span className={'fa fa-cart-shopping'}/>Buy New
                </button>
            </div>

            <div className={'col col-sm-12'} style={{
                padding: '4px',
                background: '#efefef',
                border: '1px solid #ccc',
                marginBottom: '4px',
                width: '99.5%',
                float: 'left'
            }}>
                <div className={'row'}>

                    <div className={'col col-sm-1'}></div>
                    <div className={'search-div col col col-sm-4'}>
                        <span className={'fa fa-search'}/>
                        <input name={'search'} onChange={this.handleChange}/>
                    </div>
                    <div className={'col col-sm-1'}></div>

                    {/*<button className={'btn refresh'} >
                        Search
                    </button>*/}
                </div>

            </div>

            <div className={'col col-sm-12'} style={{padding: '8px 0 2px 0', float: 'left'}}>
                {/*{this.state.modules.map((d,i)=>{
                        return(<div onClick={()=>this.fetchModules(i,d)} key={i} className={this.state.current_tab===i?'tab tab-active':'tab'}>
                            <span className={'fa fa-file-o'}/>{d.name}</div>)
                    })}*/}
            </div>

            <div style={{position: "relative", top: '100px'}}>
            <GridLayout className="layout" cols={12} rowHeight={35} width={1550} margin={[20,20]}>
                {this.state.projects.map((d, i) => {
                    return (<div style={{backgroundColor: 'lightgray', marginLeft: '20px', marginRight: '20px', borderRadius: '10px'}} key={i}
                                 data-grid={{
                                     x: 0.3 + (2 * (i % 5)),
                                     y: 0.3 + (5 * Math.floor(i / 5)), w: 2, h: 5, static: true
                                 }}>
                            <img src={map_image} style={{position: "absolute", width: '100%', height: '100%', opacity: '0.1'}}>
                            </img>
                            <div style={{textAlign: "center", margin: '10px', fontSize: '17px', padding: '7px', backgroundColor: 'lightcyan',
                            borderRadius: '10px'}}>
                                <b>{d.name}</b></div>
                            <div style={{
                                textAlign: "center",
                                margin: '10px',
                                fontSize: '13px'
                            }}><b>{d.project_type_info.name}</b></div>
                            <div style={{textAlign: "center", margin: '10px', fontSize: '13px'}}><b>EXP
                                : </b>{d.datetime}</div>
                            <div style={{
                                textAlign: "center",
                                margin: '10px',
                                fontSize: '13px'
                            }}>{d.action !== 'Approved' && d.action !== 'Rejected' ?
                                <span className={'fa fa-times'} style={{width: '100px', textAlign: 'center'}}><b>NOT PAID</b></span> :
                                <span className={'fa fa-check'} style={{width: '80px', textAlign: 'center'}}>PAID</span>}
                            </div>

                            <div style={{
                                textAlign: "center",
                                margin: '10px',
                                fontSize: '13px'
                            }}>{d.action === 'Approved' ?
                                <button className={'btn'} style={{width: '110px', textAlign: 'center'}}
                                        onClick={() => SecondLayer.show(d.name, <ProjectContainer project={d}
                                                  key={new Date().getMilliseconds()}/>)}>
                                    <span className={'fa fa-download'}/>Download
                                </button> : <b></b>}</div>

                        </div>
                    )
                })
                }
            </GridLayout>

            </div>
            {/* <div className={'col col-sm-12'}>
                    <table className={'tb'} style={{width: '100%'}}>
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Payment Date</th>
                            <th style={{position: 'sticky', left: 0, zIndex: 2}}>Land Use Name</th>
                            <th>Land Use Type</th>
                            <th>Expiry Date</th>
                            <th style={{width: '150px'}}>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.projects.map((d, i) => {
                            return (<tr key={i}
                                        onClick={() => SecondLayer.show(d.name, <ProjectContainer project={d}
                                                                                                  key={new Date().getMilliseconds()}/>)}>
                                <td>{i + 1}</td>
                                <td>{d.datetime}</td>
                                <td>
                                    <span style={{color: 'darkcyan'}}>{d.name}</span>
                                </td>
                                <td>{d.project_type_info.name}</td>
                                <td>{d.datetime}</td>
                                <td style={{fontSize: '8px'}}>
                                    {d.action !== 'Approved' && d.action !== 'Rejected' ?
                                        <button className={'btn error'} style={{width: '130px', textAlign: 'left'}}>
                                            <span className={'fa fa-times'}/>NOT PAID
                                        </button> : <button className={'btn'} style={{
                                            width: '130px', textAlign: 'left', backgroundColor: '#484'
                                        }}>
                                            <span className={'fa fa-check'}/>PAID
                                        </button>}
                                </td>
                            </tr>)
                        })}

                        <tr>
                            <td className={'noHover'} colSpan={8} style={{textAlign: 'center'}}>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize - 20
                                    })
                                    this.fetchProjectsByUrl(this.state.previous)
                                }} className={'btn default'}
                                        style={{visibility: this.state.previous !== null ? 'visible' : 'hidden'}}>Back
                                </button>
                                <b>{this.state.totalPages === 0 ? 0 : (this.state.pageSize) / 20}/{this.state.totalPages}</b>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize + 20
                                    })
                                    this.fetchProjectsByUrl(this.state.next)
                                }} className={'btn default'}
                                        style={{visibility: this.state.next !== null ? 'visible' : 'hidden'}}>Next
                                </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                </div>*/}
        </div>)
    }


}